import React from 'react';
import { useStowageStore } from 'src/context/StowageContext';
import OperationListItem from '../operations/OperationListItem';
import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';
import { onSortColumn } from 'src/utils/stowage/operationListSortUtils';

interface IOperationListBerthCallItemProps {
    berthCall: RotationBerthCall;
}

const OperationListBerthCallItemComponent: React.FC<IOperationListBerthCallItemProps> = (props) => {
    const { operationListSortColumn, isOperationListSortDesc, activeOperationsFilters, activeStowagePlan } = useStowageStore();

    return (
        <>
            {props.berthCall.cargoOperations
                .filter((op) => activeOperationsFilters.find((i) => i === op.operationType.toLowerCase()))
                .sort((a, b) => onSortColumn(operationListSortColumn, isOperationListSortDesc, a, b, activeStowagePlan))
                .map((op) => {
                    return <OperationListItem cargoOperation={op} key={'op-' + op.cargoOperationGuid} />;
                })}
        </>
    );
};

export default OperationListBerthCallItemComponent;
